import React from 'react';
import Icon from '../../../../assets/icons';
import MobileMenu from '../MobileMenu';

import { HeaderContainer, HeaderContent, Pseudo } from './styles';

const HeaderMobile = () => (
  <HeaderContainer>
    <MobileMenu />
    <HeaderContent>
      <Icon variant='logo' />
    </HeaderContent>
    <Pseudo />
  </HeaderContainer>
);

export default HeaderMobile;
